import React from "react";
import { Column, Columns, Table } from "@allxsmith/bestax-bulma";
import logo from "../Nav/img/Logo.jpg";


class PrintPartList extends React.Component {

    PartRow(part){
        const status = part.from_stock ? "From stock"
            : part.arrived ? "IN"
            : part.date_ordered ? "Awaiting"
            : part.to_be_ordered ? "To order"
            : "-";
        return (
            <tr>
                <td>{part.name}</td>
                <td>{part.part_number}</td>
                <td>{part.supplier ? part.supplier.display_name : ""}</td>
                <td>{part.inbound_carrier || ""}</td>
                <td>{part.inbound_tracking_number || ""}</td>
                <td style={{fontWeight: "bold"}}>{status}</td>
            </tr>
        )
    }

    render() {
        const partOrder = this.props.data
        const parts = partOrder.parts



        return (
            <div>
                <Columns isMultiline>
                  <img src={logo} style={{width: '110px', height: '35px'}} alt="Rentals Direct Ltd" />
                  <h2 className="job-card-print-title">Part Pick List</h2>
                </Columns>
                <br/>
                <Columns isMultiline>
                    <Column>
                        <div>
                            <Table isBordered>
                                <thead>
                                  <tr>
                                    <th>Customer</th>
                                    <th>Customer Order Number</th>
                                    <th>Part Order Number</th>
                                  </tr>
                                </thead>
                                <tr>
                                  <td data-testid={"customer"}>{partOrder.customer ? partOrder.customer.display_name : ""}</td>
                                  <td data-testid={"order-number"}>{partOrder.order_number}</td>
                                  <td data-testid={"part-order-number"}>{partOrder ? partOrder.id : ""}</td>
                                </tr>
                            </Table>
                            <Table
                                isBordered
                            >
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Part Number</th>
                                        <th>Part Supplier</th>
                                        <th>Carrier</th>
                                        <th>Tracking #</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.filter(p => !p.is_postage).map(part => this.PartRow(part))}
                                </tbody>
                            </Table>
                        </div>
                    </Column>
                </Columns>
            </div>
        );
    }

}
export default PrintPartList